export default __webpack_public_path__ + "locales/ko-KR/ArchiveDialog.json?hash=7519910bc5eac778b93395d83323cfb2";